import { createBrowserRouter } from 'react-router'
import MyCalls from '@/web-app/views/my-calls/my-calls'
import SignIn from '@/web-app/views/users/sign-in/sign-in'
import SignUp from '@/web-app/views/users/sign-up/sign-up'
import ConfirmPersonalEmail from '@/web-app/views/users/confirm-personal-email/confirm-personal-email'
import Root from '@/web-app/routes/root'
import { routes } from '@/web-app/routes/routes'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      {
        id: 'my-calls',
        path: routes.myCalls,
        element: <MyCalls />,
      },
      {
        id: 'sign-in',
        path: routes.signIn,
        element: <SignIn />,
      },
      {
        id: 'sign-up',
        path: routes.signUp,
        element: <SignUp />,
      },
      {
        id: 'confirm-personal-email',
        path: routes.confirmPersonalEmail,
        element: <ConfirmPersonalEmail />,
      },
    ],
  },
])

export default router
